import {
  AutomaticStatusWaiting,
  TimestampStatusCreating,
} from '@/features/invoice_reports/types';
import { useTranslation } from '@/i18n';
import { useMemo } from 'react';

export type AutomaticStatusTag = {
  label: string;
  status: 'success' | 'warning' | 'error' | 'default';
  key: string;
};

export type UseAutomaticStatusTagsProps = {
  automaticStatusWaiting?: AutomaticStatusWaiting;
  timestampStatusCreating?: TimestampStatusCreating;
};

export const useAutomaticStatusTags = ({
  automaticStatusWaiting,
  timestampStatusCreating,
}: UseAutomaticStatusTagsProps) => {
  const { t } = useTranslation();
  const statusTags = useMemo(() => {
    const tags: AutomaticStatusTag[] = [];

    // Handle timestamp status - when timestamp_status_creating is creating, show tag タイムスタンプ付与中
    if (timestampStatusCreating === TimestampStatusCreating.CREATING) {
      tags.push({
        label: t('label_status_timestamp_creating'),
        status: 'success',
        key: 'timestamp_creating',
      });
    }

    // Handle automatic status based on the 6 specific status mappings
    if (automaticStatusWaiting) {
      switch (automaticStatusWaiting) {
        case AutomaticStatusWaiting.BEFORE_FLAIR_UPLOAD:
        case AutomaticStatusWaiting.FLAIR_UPLOADED:
        case AutomaticStatusWaiting.BEFORE_OCR_UPLOAD:
        case AutomaticStatusWaiting.OCR_UPLOADED:
          tags.push({
            label: t('label_status_ocr_reading'),
            status: 'success',
            key: 'ocr_reading',
          });
          break;
        case AutomaticStatusWaiting.BEFORE_STREAMED_UPLOAD:
        case AutomaticStatusWaiting.STREAMED_UPLOADED:
          tags.push({
            label: t('label_status_operator_input'),
            status: 'success',
            key: 'operator_input',
          });
          break;
        default:
          break;
      }
    }

    return tags;
  }, [automaticStatusWaiting, timestampStatusCreating, t]);

  return {
    statusTags,
  };
};
